/** @module utils/DateUtils/addHours */

/**
 * Adds hours to a date.
 *
 * @param {Date} time the time to increment
 * @param {number} hours the number of hours to increment by.
 * @return a new Date with the new hours set.
 */
export default function addHours(time, hours) {
  var t = new Date(time.getTime());
  t.setHours(t.getHours() + hours);
  return t;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-md/es/utils/DateUtils/addHours.js
// module id = 336
// module chunks = 0